import { Address, GenderCode } from '@prismo-io/schemas';
import type { ApiClient } from '@prismo-io/schemas';
import { z } from 'zod';

export const PrivacyParamsSchema = z.object({
  id: z.string().uuid(),
  is_private: z.boolean(),
});

export type PrivacyParamsSchemaT = z.infer<typeof PrivacyParamsSchema>;

export const MarketingMailsParamsSchema = z.object({
  id: z.string().uuid(),
  can_receive_marketing_mails: z.boolean(),
});

export type MarketingMailsParamsSchemaT = z.infer<
  typeof MarketingMailsParamsSchema
>;

export const ParamsSchema = z.object({
  id: z.string().uuid(),
  first_name: z.string(),
  last_name: z.string(),

  // email: z.string().trim().min(1).email(),

  // password: z.string().trim().min(6).nullable(),
  // confirmPassword: z.string().nullable(),

  website: z.string().nullable(),
  show_website: z.boolean(),
  phone: z.string().nullable(),
  show_phone: z.boolean(),

  facebook: z.string().nullable(),
  show_facebook: z.boolean(),
  linked_in: z.string().nullable(),
  show_linked_in: z.boolean(),
  twitter: z.string().nullable(),
  show_twitter: z.boolean(),

  address: Address.pick({
    locality: true,
    nation: true,
    place_id: true,
  }).optional(),
  show_address: z.boolean(),

  gender_id: GenderCode.nullable(),
  birth_year: z.number().nullable(),

  description: z.string().nullable(),

  avatar: z
    .object({
      src: z.string(),
      blob: z.any().nullable().optional(),
      type: z.any().nullable().optional(),
    })
    .nullable()
    .optional(),
  cv: z.string().nullable(),
});

export type ParamsSchemaT = z.infer<typeof ParamsSchema>;

const ResultSchema = z.boolean();

export type ResultSchemaT = z.infer<typeof ResultSchema>;

export const updateUser = async (
  client: ApiClient,
  params: ParamsSchemaT
): Promise<ResultSchemaT> => {
  const paramsWithoutAvatar = { ...params, avatar: null };

  await client
    .from('users')
    .update(paramsWithoutAvatar)
    .eq('id', paramsWithoutAvatar.id)
    .throwOnError();

  return ResultSchema.parse(true);
};

export const updateUserPrivacy = async (
  client: ApiClient,
  params: PrivacyParamsSchemaT
): Promise<ResultSchemaT> => {
  const validatedParams = PrivacyParamsSchema.parse(params);

  await client
    .from('users')
    .update(validatedParams)
    .eq('id', validatedParams.id)
    .throwOnError();

  return ResultSchema.parse(true);
};

export const updateUserMarketingMails = async (
  client: ApiClient,
  params: MarketingMailsParamsSchemaT
): Promise<ResultSchemaT> => {
  const validatedParams = MarketingMailsParamsSchema.parse(params);

  await client
    .from('users')
    .update(validatedParams)
    .eq('id', validatedParams.id)
    .throwOnError();

  return ResultSchema.parse(true);
};
